import { useTranslation } from "react-i18next";
import EnrollmentsTable from "../../components/tables/EnrollmentsTable";
import BasePage from "../common/BasePage";

export default function EnrollmentsPage() {
  const { t } = useTranslation();

  return (
    <BasePage title={t("enrollments_page.enrollments")}>
      <EnrollmentsTable />
    </BasePage>
  );
}
